import type { Dictionary } from './en';

export const pt: Dictionary = {
  'common.cancel': 'Cancelar',
  'common.back': 'Voltar',
  'common.retry': 'Tentar novamente',
  'common.copy': 'Copiar',
  'common.copied': 'Copiado',
  'common.share': 'Partilhar',
  'common.delete': 'Eliminar',
  'common.revoke': 'Revogar',
  'common.close': 'Fechar',
  'common.loading': 'A carregar',
  'common.optional': 'Opcional',
  'common.or': 'ou',
  'common.none': 'Nenhum',
  'common.required': 'Obrigatório',
  'common.notSet': 'Por definir',
  'common.skipToContent': 'Ir para o conteúdo principal',
  'common.moment': 'Um momento…',

  'brand.tagline': 'Partilhe um vídeo. Uma única vez.',
  'brand.home': 'BOOMSHOT - início',
  'brand.footerLimit':
    'O BOOMSHOT garante uma reprodução única segura. Nenhuma tecnologia consegue impedir uma captura ou gravação de ecrã.',

  'nav.main': 'Navegação principal',
  'nav.myVideos': 'Os meus vídeos',
  'nav.privacy': 'Privacidade',
  'nav.signIn': 'Iniciar sessão',
  'nav.signOut': 'Terminar sessão',
  'nav.settings': 'Definições da conta',
  'nav.openMenu': 'Abrir o menu',
  'nav.closeMenu': 'Fechar o menu',

  'theme.light': 'Tema claro - mudar para escuro',
  'theme.dark': 'Tema escuro - mudar para automático',
  'theme.system': 'Tema automático - mudar para claro',
  'theme.label': 'Aspeto',
  'theme.optionSystem': 'Automático',
  'theme.optionLight': 'Claro',
  'theme.optionDark': 'Escuro',

  'language.label': 'Idioma',
  'language.change': 'Mudar de idioma',

  'landing.title': 'Partilhe um vídeo. Uma única vez.',
  'landing.subtitle':
    'A sua ligação privada deixa de funcionar após a primeira visualização e o vídeo é eliminado automaticamente.',
  'landing.ctaNew': 'Criar uma ligação privada',
  'landing.ctaSend': 'Enviar um vídeo',
  'landing.haveAccount': 'Já tenho conta',
  'landing.assure.encrypted': 'Cifrado em trânsito',
  'landing.assure.deleted': 'Eliminado após a visualização',
  'landing.assure.noReplay': 'Sem repetição',
  'landing.how': 'Três passos. Nenhuma segunda oportunidade.',
  'landing.step1.title': 'Envie',
  'landing.step1.body':
    'Largue um vídeo. É convertido em fragmentos servidos a partir de armazenamento privado, nunca de um URL público.',
  'landing.step2.title': 'Configure',
  'landing.step2.body':
    'Validade, código de acesso, marca de água, mensagem. A ligação leva um segredo que nunca sai do seu dispositivo.',
  'landing.step3.title': 'Uma única visualização',
  'landing.step3.body':
    'A primeira sessão reserva a ligação de forma definitiva. No fim, os ficheiros são destruídos no servidor.',
  'landing.limits.title': 'O que o BOOMSHOT faz',
  'landing.limits.guaranteed': 'Garantido no servidor',
  'landing.limits.g1': 'Uma única sessão de reprodução por ligação, reservada de forma atómica.',
  'landing.limits.g2': 'Fragmentos servidos com tokens de curta duração, sem URL permanente.',
  'landing.limits.g3':
    'Eliminação verificada do ficheiro original, dos fragmentos e das miniaturas.',

  'auth.signIn.title': 'Iniciar sessão',
  'auth.signIn.subtitle': 'Aceda aos seus vídeos e às suas ligações ativas.',
  'auth.signIn.submit': 'Iniciar sessão',
  'auth.signIn.noAccount': 'Ainda não tem conta?',
  'auth.signIn.create': 'Criar uma conta',
  'auth.signIn.magicLink': 'Receber uma ligação de acesso',
  'auth.signIn.usePassword': 'Usar uma palavra-passe',
  'auth.signIn.forgot': 'Esqueci-me da palavra-passe',
  'auth.signIn.magicSent':
    'Se existir uma conta com este endereço, acabámos de enviar uma ligação de acesso. Funciona apenas uma vez.',
  'auth.signUp.title': 'Criar uma conta',
  'auth.signUp.subtitle':
    'É necessária uma conta para enviar. Os seus destinatários nunca precisam de uma.',
  'auth.signUp.submit': 'Criar a minha conta',
  'auth.signUp.hasAccount': 'Já está registado?',
  'auth.signUp.terms':
    'Compreendo que um vídeo reproduzido num navegador pode sempre ser capturado por uma gravação de ecrã e que o BOOMSHOT garante uma reprodução única, não uma proteção anticópia.',
  'auth.reset.title': 'Esqueci-me da palavra-passe',
  'auth.reset.subtitle': 'Vamos enviar-lhe uma ligação para a redefinir.',
  'auth.reset.submit': 'Enviar a ligação',
  'auth.reset.sent':
    'Se existir uma conta com este endereço, acabámos de enviar um email de redefinição. Verifique também a pasta de spam.',
  'auth.reset.back': 'Voltar ao início de sessão',
  'auth.callback.title': 'A iniciar sessão',
  'auth.callback.subtitle': 'A verificar a sua ligação…',
  'auth.callback.invalid': 'Esta não é uma ligação de acesso válida.',
  'auth.callback.requestNew': 'Pedir uma nova ligação',
  'auth.google': 'Continuar com Google',
  'auth.email': 'Endereço de email',
  'auth.emailPlaceholder': 'voce@exemplo.com',
  'auth.password': 'Palavra-passe',
  'auth.passwordConfirm': 'Confirmar a palavra-passe',
  'auth.passwordHint': 'Pelo menos 10 caracteres, com maiúscula, minúscula e algarismo.',
  'auth.magicHint': 'Vai receber uma ligação de uso único, sem palavra-passe.',
  'auth.confirmEmailPrompt': 'Confirme o seu endereço de email para concluir o acesso',

  'authError.invalidCredential': 'Endereço de email ou palavra-passe incorretos.',
  'authError.emailInUse':
    'Não foi possível criar essa conta. Tente iniciar sessão ou redefinir a palavra-passe.',
  'authError.weakPassword': 'Palavra-passe demasiado fraca.',
  'authError.tooManyRequests': 'Demasiadas tentativas. Tente novamente dentro de alguns minutos.',
  'authError.network': 'Sem ligação. Verifique a sua rede.',
  'authError.popupClosed': 'A janela foi fechada antes de concluir o acesso.',
  'authError.popupBlocked': 'O navegador bloqueou a janela.',
  'authError.recentLogin': 'Por segurança, inicie sessão novamente antes de continuar.',
  'authError.invalidActionCode': 'Esta ligação de acesso é inválida ou já foi usada.',
  'authError.expiredActionCode': 'Esta ligação de acesso expirou. Peça uma nova.',
  'authError.generic': 'Algo correu mal. Tente novamente.',

  'dashboard.title': 'Os meus vídeos',
  'dashboard.subtitle': 'Cada ligação permite exatamente uma sessão de reprodução.',
  'dashboard.send': 'Enviar um vídeo',
  'dashboard.metric.activeLinks': 'Ligações ativas',
  'dashboard.metric.watched': 'Vídeos vistos',
  'dashboard.metric.storage': 'Armazenamento temporário',
  'dashboard.search': 'Pesquisar',
  'dashboard.searchPlaceholder': 'Pesquisar por nome ou destinatário',
  'dashboard.filters': 'Filtros',
  'dashboard.filterStatus': 'Estado',
  'dashboard.filterAll': 'Todos os estados',
  'dashboard.sort': 'Ordenação',
  'dashboard.sortNewest': 'Mais recentes',
  'dashboard.sortOldest': 'Mais antigos',
  'dashboard.sortExpiring': 'A expirar em breve',
  'dashboard.empty.title': 'Ainda não há vídeos',
  'dashboard.empty.body':
    'Envie o seu primeiro vídeo: será convertido, protegido por uma ligação de uso único e depois eliminado após a primeira visualização.',
  'dashboard.noResults.title': 'Sem resultados',
  'dashboard.noResults.body':
    'Nenhum vídeo corresponde a esta pesquisa. Experimente outro termo ou limpe os filtros.',
  'dashboard.loadError': 'Não foi possível carregar os seus vídeos. Verifique a ligação.',
  'dashboard.loadBlocked': 'Não foi possível carregar os seus vídeos. O serviço não está configurado corretamente - o problema não é seu.',
  'dashboard.expiresIn': 'Expira {when}',
  'dashboard.viewedAt': 'Visto {when}',
  'dashboard.createdAt': 'Criado {when}',
  'dashboard.forRecipient': 'Para {name}',

  'status.processing': 'Em processamento',
  'status.ready': 'Pronto',
  'status.opened': 'Ligação aberta',
  'status.playing': 'Em reprodução',
  'status.watched': 'Visto',
  'status.expired': 'Expirado',
  'status.deleted': 'Eliminado',
  'status.error': 'Erro',

  'upload.title': 'Enviar um vídeo',
  'upload.subtitle':
    'Será convertido, protegido por uma ligação de uso único e depois eliminado após a primeira visualização.',
  'upload.drop': 'Largue aqui o seu vídeo',
  'upload.formats': '{formats} - até {size}',
  'upload.choose': 'Escolher um ficheiro',
  'upload.progress': 'Progresso do envio',
  'upload.inProgress': 'A enviar…',
  'upload.converting': 'A converter…',
  'upload.cancelUpload': 'Cancelar o envio',
  'upload.processingNote':
    'A converter em fragmentos seguros. Não precisa de esperar: gere a ligação agora e ela funcionará assim que isto terminar.',
  'upload.restart': 'Recomeçar',
  'upload.error.format': 'Formato não suportado. Use um ficheiro MP4, MOV ou WebM.',
  'upload.error.tooLarge': 'Ficheiro demasiado grande (máximo {size}).',
  'upload.error.notVideo': 'Este ficheiro não parece um vídeo válido.',
  'upload.error.unreadable': 'Não foi possível ler este ficheiro como vídeo.',
  'upload.error.tooLong': 'Vídeo demasiado longo ({duration}). Máximo {max}.',
  'upload.error.failed': 'O envio falhou. Verifique a ligação e tente novamente.',
  'upload.error.transcode':
    'A conversão deste vídeo falhou. O ficheiro foi eliminado. Experimente outro formato.',
  'upload.error.tracking': 'Perdeu-se o acompanhamento do processamento. Recarregue a página.',

  'config.expiry': 'Validade da ligação',
  'config.expiry1h': '1 hora',
  'config.expiry24h': '24 h',
  'config.expiry3d': '3 dias',
  'config.expiry7d': '7 dias',
  'config.expiryCustom': 'Data personalizada',
  'config.expiryDate': 'Data e hora de validade',
  'config.pin': 'Código de acesso',
  'config.pinHint': 'De 4 a 8 algarismos. Envie-o separadamente da ligação.',
  'config.advanced': 'Opções avançadas',
  'config.internalName': 'Nome interno',
  'config.internalNameHint': 'Visível apenas para si, nunca para o destinatário.',
  'config.recipient': 'Nome do destinatário',
  'config.recipientHint': 'Mostrado na marca de água quando esta está ativa.',
  'config.watermark': 'Marca de água',
  'config.watermarkNone': 'Nenhuma',
  'config.watermarkSubtle': 'Discreta',
  'config.watermarkReinforced': 'Reforçada',
  'config.message': 'Mensagem ao destinatário',
  'config.messagePlaceholder': 'Opcional - mostrada antes da reprodução',
  'config.submit': 'Criar a ligação privada',
  'config.alwaysDeleted':
    'A eliminação após a visualização está sempre ativa e não pode ser desativada.',
  'config.linkFailed': 'Não foi possível gerar a ligação.',

  'ready.eyebrow': 'Ligação gerada',
  'ready.title': 'A sua ligação está pronta. Funciona uma vez.',
  'ready.meta': '{name} · {duration} · expira a {date}',
  'ready.stillProcessing':
    'Esta ligação já funciona, mas o vídeo ainda está a ser processado. Se for aberta de imediato, o destinatário só terá de esperar um momento.',
  'ready.secureLink': 'Ligação segura',
  'ready.copyFailed': 'Não foi possível copiar. Selecione a ligação manualmente.',
  'ready.shareTitle': 'Vídeo de visualização única',
  'ready.shareText': 'Este vídeo só pode ser visto uma vez.',
  'ready.pinWarning':
    'O código de acesso é deliberadamente excluído da partilha. Transmita-o por outro canal (SMS, chamada), nunca na mesma mensagem que a ligação.',
  'ready.fragmentNote':
    'A parte da ligação a seguir ao {hash} é o segredo de acesso. Nunca é enviada para os nossos servidores - copie a ligação por inteiro.',
  'ready.protections': 'Proteções ativas',
  'ready.protectionSingle': 'Uma única sessão de reprodução',
  'ready.protectionDelete': 'Eliminação após a visualização',
  'ready.protectionPin': 'Código de acesso obrigatório',
  'ready.protectionsNote':
    'Estas medidas garantem uma reprodução única. Não conseguem impedir uma captura ou gravação de ecrã.',
  'ready.qr': 'Código QR',
  'ready.qrAlt': 'Código QR da ligação segura para {name}',
  'ready.sendAnother': 'Enviar outro vídeo',
  'ready.backToDashboard': 'Voltar ao painel',
  'ready.leaveWarnTitle': 'Ainda não copiou este link',
  'ready.leaveWarnBody':
      'É a única vez que é mostrado. Não fica guardado em lado nenhum: se sair agora sem o copiar ou partilhar, ninguém - nem mesmo você - poderá recuperá-lo depois. Teria de revogar o link deste vídeo e enviá-lo novamente.',
  'ready.leaveAnyway': 'Sair sem copiar',
  'ready.copyNow': 'Copiar o link',
  'ready.watermarkNone': 'Sem marca de água',
  'ready.watermarkSubtle': 'Marca de água discreta',
  'ready.watermarkReinforced': 'Marca de água reforçada',

  'detail.notFound.title': 'Vídeo não encontrado',
  'detail.notFound.body': 'Este vídeo já não existe ou não lhe pertence.',
  'detail.duration': 'Duração',
  'detail.size': 'Tamanho',
  'detail.created': 'Criado a',
  'detail.recipient': 'Destinatário',
  'detail.expiry': 'Validade',
  'detail.viewedOn': 'Visto a',
  'detail.deletedOn': 'Eliminado a',
  'detail.pinRequired': 'Obrigatório',
  'detail.consumedNote':
    'Este vídeo foi visto. A ligação está definitivamente inutilizável e os ficheiros foram eliminados do armazenamento.',
  'detail.failedNote':
    'O processamento deste vídeo falhou. Não foi gerada nenhuma ligação e os ficheiros temporários foram eliminados.',
  'detail.lastError': 'Último erro comunicado pelo servidor:',
  'detail.copyLink': 'Copiar a ligação',
  'detail.secretLost':
    'O segredo da ligação nunca é guardado: só aparece no momento da geração. Revogue esta ligação e crie uma nova se a tiver perdido.',
  'detail.revoke': 'Revogar a ligação',
  'detail.deleteNow': 'Eliminar agora',
  'detail.reuse': 'Reutilizar estas definições',
  'detail.revokeTitle': 'Revogar esta ligação?',
  'detail.revokeBody':
    'A ligação deixará de funcionar imediatamente. O vídeo será depois eliminado.',
  'detail.revoked': 'Ligação revogada.',
  'detail.deleteTitle': 'Eliminar este vídeo?',
  'detail.deleteBody':
    'O ficheiro original, os fragmentos e as miniaturas serão destruídos. Esta ação é irreversível.',
  'detail.deleteStarted': 'Eliminação iniciada.',
  'detail.actionFailed': 'Ação impossível de momento.',

  'settings.title': 'Conta e privacidade',
  'settings.subtitle': 'O que o BOOMSHOT guarda e o que não consegue garantir.',
  'settings.identity': 'Identidade',
  'settings.anonymous': 'Conta anónima',
  'settings.memberSince': 'Membro desde {date}',
  'settings.dataKept': 'Dados conservados',
  'settings.dataKept1':
    'Depois de eliminar um vídeo, o BOOMSHOT guarda apenas um vestígio mínimo: estado, data de criação, data de visualização, data de eliminação, duração e o nome que escolheu.',
  'settings.dataKept2':
    'Não é guardado nenhum endereço IP completo. Não fica nenhuma miniatura, nenhum fragmento de vídeo nem nenhum ficheiro original.',
  'settings.limitsTitle': 'Limites reais da proteção',
  'settings.limits1':
    'Um vídeo reproduzido num navegador pode sempre ser copiado: captura de ecrã, gravação de ecrã, uma câmara externa a filmar o ecrã ou extração por alguém com conhecimentos técnicos.',
  'settings.limits2':
    'O BOOMSHOT garante que uma ligação abre exatamente uma sessão de reprodução e que os ficheiros são depois destruídos no servidor. Não garante que a imagem não possa ser copiada.',
  'settings.deleteAccount': 'Eliminar a conta',
  'settings.deleteAccountBody':
    'Todos os seus vídeos, ligações e ficheiros serão destruídos. Esta ação é irreversível.',
  'settings.deleteConfirmLabel': 'Escreva ELIMINAR para confirmar',
  'settings.deleteConfirmWord': 'ELIMINAR',
  'settings.deleteSubmit': 'Eliminar definitivamente a minha conta',
  'settings.deleted': 'Conta eliminada.',
  'settings.signOutFailed': 'Não foi possível terminar a sessão de momento.',

  'viewer.checking': 'A verificar a ligação…',
  'viewer.preparing': 'Quase lá - o vídeo do remetente ainda está a ser preparado.',
  'viewer.eyebrow': 'Visualização única',
  'viewer.title': 'Este vídeo só pode ser visto uma vez.',
  'viewer.subtitle':
    'Inicie-o quando estiver pronto e certifique-se de que tem uma ligação estável.',
  'viewer.sender': 'Remetente',
  'viewer.message': 'Mensagem',
  'viewer.duration': 'Duração',
  'viewer.deadline': 'Disponível até',
  'viewer.warning':
    'Assim que iniciar a reprodução, a ligação torna-se definitivamente inutilizável. Não haverá repetição, nem retrocesso, nem uma segunda sessão - mesmo que feche a página por engano.',
  'viewer.start': 'Iniciar a visualização única',
  'viewer.startWithPin': 'Validar e iniciar a visualização única',
  'viewer.pinHint': 'O remetente enviou-lhe este código em separado.',
  'viewer.pinWrong': 'Código incorreto.',
  'viewer.pinWrongRetry': 'Código incorreto. Tente novamente dentro de {seconds} s.',
  'viewer.retryIn': 'Nova tentativa dentro de {seconds} s',
  'viewer.noPreload': 'Nenhum fragmento de vídeo é carregado antes da sua confirmação.',
  'viewer.checkFailed': 'Não foi possível verificar esta ligação de momento.',
  'viewer.claimFailed': 'Não foi possível abrir a sessão de reprodução.',
  'viewer.unavailable.title': 'Esta ligação já não é válida',
  'viewer.unavailable.body':
    'Pode já ter sido usada ou revogada, ou pode nunca ter existido. Por motivos de privacidade não podemos dizer mais. Peça uma nova ligação ao remetente.',
  'viewer.expired.title': 'Esta ligação expirou',
  'viewer.expired.body':
    'O prazo definido pelo remetente já passou e o vídeo foi eliminado. Peça uma nova ligação se ainda precisar de o ver.',
  'viewer.used.title': 'Este vídeo já foi aberto',
  'viewer.used.body':
    'Já foi iniciada uma sessão de reprodução para esta ligação. Não pode criar outra, e o vídeo foi eliminado.',
  'viewer.stillProcessing.title': 'Este vídeo ainda está a ser preparado',
  'viewer.stillProcessing.body':
    'Isto está a demorar mais do que o habitual. A ligação está bem - reabra-a daqui a uns minutos e o vídeo deverá estar pronto.',
  'viewer.consumed.title': 'Vídeo visto e eliminado',
  'viewer.consumed.body':
    'A reprodução terminou. A ligação está agora inutilizável e os ficheiros foram destruídos nos nossos servidores.',
  'viewer.error.title': 'Reprodução impossível',

  'player.preloading': 'Pré-carregamento seguro…',
  'player.tapToPlay': 'Toque para reproduzir',
  'player.tapToPlayHint': 'A visualização única começa assim que tocar em reproduzir.',
  'player.stalled': 'Ligação instável - a reprodução recomeça automaticamente.',
  'player.play': 'Reproduzir',
  'player.pause': 'Pausar',
  'player.mute': 'Desativar o som',
  'player.unmute': 'Ativar o som',
  'player.volume': 'Volume',
  'player.fullscreen': 'Ecrã inteiro',
  'player.exitFullscreen': 'Sair do ecrã inteiro',
  'player.progress': 'Progresso da reprodução',
  'player.unsupported': 'O seu navegador não consegue reproduzir este vídeo.',
  'player.fatal': 'A reprodução foi interrompida e não pode recomeçar.',

  'notFound.title': 'Página não encontrada',
  'notFound.body':
    'Este endereço não corresponde a nada. Se recebeu uma ligação para um vídeo, verifique se foi copiada por inteiro - a parte a seguir ao {hash} é indispensável.',
  'notFound.home': 'Voltar ao início',

  'apiError.network': 'Sem ligação. Verifique a sua rede.',
  'apiError.unauthenticated': 'Sessão expirada. Inicie sessão novamente.',
  'apiError.forbidden': 'Acesso negado.',
  'apiError.notFound': 'Não encontrado.',
  'apiError.conflict': 'Esta ação já foi efetuada.',
  'apiError.rateLimited': 'Demasiadas tentativas. Tente novamente daqui a pouco.',
  'apiError.badResponse': 'Resposta inesperada do servidor.',
  'apiError.internal': 'Algo correu mal do nosso lado.',
  'apiError.badRequest': 'Pedido inválido.',

  'validation.required': 'Obrigatório',
  'validation.invalidFormat': 'Formato inválido',
  'validation.tooLong': 'Demasiado longo',
  'validation.unsafeCharacters': 'Caracteres não permitidos',
  'validation.email': 'Endereço de email inválido',
  'validation.passwordMin': 'Pelo menos 10 caracteres',
  'validation.passwordComplexity': 'Deve conter uma minúscula, uma maiúscula e um algarismo',
  'validation.passwordMismatch': 'As palavras-passe não coincidem',
  'validation.termsRequired': 'Tem de aceitar as condições',
  'validation.pinDigits': 'O código tem de ser numérico',
  'validation.pinMin': 'Pelo menos {min} algarismos',
  'validation.pinMax': 'No máximo {max} algarismos',
  'validation.messageTooLong': 'Mensagem demasiado longa (máximo 500 caracteres)',
  'validation.dateRequired': 'Escolha uma data',
  'validation.dateTooSoon': 'A data tem de ser pelo menos 5 minutos no futuro',
  'validation.dateTooFar': 'A data não pode ultrapassar os 30 dias',
  'validation.confirmDelete': 'Escreva ELIMINAR para confirmar',

  'state.errorTitle': 'Algo correu mal',
};
